import { useTranslation } from 'react-i18next';

import { useMytaverseEvent } from '@core/dashboard/providers';
import { useMytaverse } from '@providers/MytaverseProvider';
import { NavigationModeType } from '@constants/navigationMode';
import { PollyLanguage, voicesByLanguage } from '@constants/polly';
import { POLLY_TO_LANGUAGE_CODE } from '@constants/language';

import SettingsGeneralView from './SettingsGeneralView';
const SettingsGeneral = () => {
  const { selectLanguage, selectedLanguage } = useMytaverse();
  const {
    updateRoomScale,
    gameSound,
    setGameSound,
    participantsSound,
    setParticipantsSound,
    externalKeyboardConnected,
    setExternalKeyboardConnected,
    currentEventParticipant,
    selectNavigationMode,
    currentEvent,
  } = useMytaverseEvent();

  const aiAssistant = currentEvent?.settings?.aiAssistant;
  const configuredLanguages = aiAssistant
    ? (
        [aiAssistant.baseLanguage, ...(aiAssistant.languages ?? [])].filter(
          Boolean,
        ) as PollyLanguage[]
      )
        .filter((lang) => voicesByLanguage[lang])
        .map((lang) => POLLY_TO_LANGUAGE_CODE[lang] ?? lang)
    : undefined;
  const { t: translate } = useTranslation();

  const selectedNavigationMode =
    (currentEventParticipant?.navigationMode as NavigationModeType) ||
    NavigationModeType.StrafeMode;

  const handleChange = (event: Event, newValue: number | number[]) => {
    setGameSound((newValue as number) / 100);
  };

  const handleLoudness = (event: Event, newValue: number | number[]) => {
    setParticipantsSound((newValue as number) / 100);
  };

  return (
    <SettingsGeneralView
      selectLanguage={selectLanguage}
      selectedLanguage={selectedLanguage}
      selectNavigationMode={selectNavigationMode}
      selectedNavigationMode={selectedNavigationMode}
      translate={translate}
      participantsSound={participantsSound}
      gameSound={gameSound}
      handleChange={handleChange}
      handleLoudness={handleLoudness}
      updateRoomScale={updateRoomScale}
      externalKeyboardConnected={externalKeyboardConnected}
      setExternalKeyboardConnected={setExternalKeyboardConnected}
      languages={configuredLanguages}
    />
  );
};

export default SettingsGeneral;
